/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { TimegateSettings } from './TimegateSettings';
import {
  TimegateSettingsFromJSON,
  TimegateSettingsFromJSONTyped,
  TimegateSettingsToJSON,
} from './TimegateSettings';

/**
 *
 * @export
 * @interface CampaignSettings
 */
export interface CampaignSettings {
  /**
   * Number of items (calls) to process in parallel per agent
   * @type {number}
   * @memberof CampaignSettings
   */
  agentMultiplier?: number;
  /**
   *
   * @type {string}
   * @memberof CampaignSettings
   */
  campaignSettingsId?: string;
  /**
   * Classification of the campaign, e.g. marketing
   * @type {string}
   * @memberof CampaignSettings
   */
  classification?: CampaignSettingsClassificationEnum;
  /**
   *
   * @type {number}
   * @memberof CampaignSettings
   */
  companyId: number;
  /**
   * CustomIVR to play when a call is connected before the agent. References a CustomIvr from DP
   * @type {number | null}
   * @memberof CampaignSettings
   */
  customIvrDetailsId?: number | null;
  /**
   *
   * @type {number}
   * @memberof CampaignSettings
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof CampaignSettings
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof CampaignSettings
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof CampaignSettings
   */
  dateModifiedIso?: string;
  /**
   * Enable internal DNC/DNT checks for this campaign
   * @type {boolean}
   * @memberof CampaignSettings
   */
  enableInternalDnc?: boolean;
  /**
   * Enable national DNC/DNT checks for this campaign
   * @type {boolean}
   * @memberof CampaignSettings
   */
  enableNationalDnc?: boolean;
  /**
   *
   * @type {string}
   * @memberof CampaignSettings
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CampaignSettings
   */
  key: string;
  /**
   * max total calls to allow per item
   * @type {number}
   * @memberof CampaignSettings
   */
  maxCallAttempts?: number;
  /**
   * Playbook to use. References a playbook from DP
   * @type {number | null}
   * @memberof CampaignSettings
   */
  playbookId?: number | null;
  /**
   * Time zone enforcement settings
   * @type {TimegateSettings}
   * @memberof CampaignSettings
   */
  timegateSettings?: TimegateSettings;
}

/**
 * @export
 */
export const CampaignSettingsClassificationEnum = {
  Marketing: 'marketing',
  Informational: 'informational',
} as const;
export type CampaignSettingsClassificationEnum =
  (typeof CampaignSettingsClassificationEnum)[keyof typeof CampaignSettingsClassificationEnum];

/**
 * Check if a given object implements the CampaignSettings interface.
 */
export function instanceOfCampaignSettings(
  value: object,
): value is CampaignSettings {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function CampaignSettingsFromJSON(json: any): CampaignSettings {
  return CampaignSettingsFromJSONTyped(json, false);
}

export function CampaignSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CampaignSettings {
  if (json == null) {
    return json;
  }
  return {
    agentMultiplier:
      json['agent_multiplier'] == null ? undefined : json['agent_multiplier'],
    campaignSettingsId:
      json['campaign_settings_id'] == null
        ? undefined
        : json['campaign_settings_id'],
    classification:
      json['classification'] == null ? undefined : json['classification'],
    companyId: json['company_id'],
    customIvrDetailsId:
      json['custom_ivr_details_id'] == null
        ? undefined
        : json['custom_ivr_details_id'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    enableInternalDnc:
      json['enable_internal_dnc'] == null
        ? undefined
        : json['enable_internal_dnc'],
    enableNationalDnc:
      json['enable_national_dnc'] == null
        ? undefined
        : json['enable_national_dnc'],
    id: json['id'],
    key: json['key'],
    maxCallAttempts:
      json['max_call_attempts'] == null ? undefined : json['max_call_attempts'],
    playbookId: json['playbook_id'] == null ? undefined : json['playbook_id'],
    timegateSettings:
      json['timegate_settings'] == null
        ? undefined
        : TimegateSettingsFromJSON(json['timegate_settings']),
  };
}

export function CampaignSettingsToJSON(value?: CampaignSettings | null): any {
  if (value == null) {
    return value;
  }
  return {
    agent_multiplier: value['agentMultiplier'],
    campaign_settings_id: value['campaignSettingsId'],
    classification: value['classification'],
    company_id: value['companyId'],
    custom_ivr_details_id: value['customIvrDetailsId'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    enable_internal_dnc: value['enableInternalDnc'],
    enable_national_dnc: value['enableNationalDnc'],
    id: value['id'],
    key: value['key'],
    max_call_attempts: value['maxCallAttempts'],
    playbook_id: value['playbookId'],
    timegate_settings: TimegateSettingsToJSON(value['timegateSettings']),
  };
}
